export enum PAYMENT_METHODS_TYPE_ENUM {
  CREDCARD = 'credit_card',
  CREDCARD_SUB = 'credit_card_subscription',
  BILLET = 'boleto_parcelado',
  BILLET_SUB = 'boleto_subscription',
  PIX = 'pix',
  FREE = 'free',
}
